import { base } from "./_internal";

/**
 * UnauthorizedError
 */
export class UnauthorizedError extends base.ApplicationError {
	public static override readonly code: number = 401;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Unauthorized");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * AuthenticationError
 */
export class AuthenticationError extends UnauthorizedError {
	public static override readonly code: number = 452;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Authentication error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * AccountLockedError
 */
export class AccountLockedError extends AuthenticationError {
	public static override readonly code: number = 453;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Account locked");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * AccessForbiddenError
 */
export class AccessForbiddenError extends base.ApplicationError {
	public static override readonly code: number = 403;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Access forbidden");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * IdentityError
 */
export class IdentityError extends base.ApplicationError {
	public static override readonly code: number = 470;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Identity error");
		Object.setPrototypeOf(this, trueProto);
	}
}
